export default {
  fondsInnerTransferDetail: {
    component: () =>
      import(
        /* webpackChunkName: "transfer_detail" */ "../fondsInnerTransfer/detailView/FondsInnerTransferDetail"
      ),
  },
};
